import React from 'react';
import Footer from '../Footer';
import '../ImportantView/CRV.css';
import { useEffect } from 'react';

function WebsiteUrlF () {

    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);

    return (
        <div>
            <section>
            <div className='content holds-the-iframe'>
            <iframe className='frame'  src="https://script.google.com/macros/s/AKfycbyCEhkmn9KgX8FwcqZDK7KEBTUwwKAN3UJz9aGDTP9qYB037PkC4uXjQT8h3OvoFlTBBQ/exec " width={'100%'} height={'700px'}></iframe>   
            </div>
            <div class='air air1'></div>
            <div class='air air2'></div>
            <div class='air air3'></div>
            <div class='air air4'></div>
            </section>
            <Footer/>     
        </div>
    );
}

export default WebsiteUrlF;
